var $16cbb8b4d0babfdc$exports = {};
$16cbb8b4d0babfdc$exports = {
    "rangeOverflow": (args)=>`Waarde moet ${args.maxValue} of eerder zijn.`,
    "rangeReversed": `De startdatum moet voor de einddatum liggen.`,
    "rangeUnderflow": (args)=>`Waarde moet ${args.minValue} of later zijn.`,
    "unavailableDate": `Geselecteerde datum niet beschikbaar.`
};


export {$16cbb8b4d0babfdc$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
